import type { SingleOccurrenceFormType } from './SingleOccurrenceForm';

export const toPayload = (formData: SingleOccurrenceFormType) => {
  return {
    lottery: {
      occurrence: {
        occurrenceType: 'SINGLE',
        startDate: formData.startDate,
        endDate: formData.endDate,
      },
      drawDay: formData.drawDay,
      drawTime: formData.drawTime,
    } as const,
  };
};
